<ion-content class="ion-padding">
    <app-autosave
            #autosave
            [hidden]="!canEdit"
            [isSaving]="autoSaving"
            [pendingChanges]="hasPendingChanges"
    ></app-autosave>

    <div class="max-page-width">
        <ion-item lines="none" mode="ios" class="title-with-back-button">
            <ion-button fill="clear" mode="ios" color="primary" (click)="goBack()">
                <ion-icon class="bp-arrow-left"></ion-icon>
            </ion-button>
            <ion-label class="ion-text-center ion-text-wrap" color="primary">
                {{ getText(processConfig?.globalizationConfig, 'title') |
                    uppercase }}
            </ion-label>
        </ion-item>

        <app-step-description
                [employee]="user"
                [description]="getText(processConfig?.globalizationConfig, 'instructions')"
        ></app-step-description>

        <ion-item lines="none" mode="ios" class="para-content">
            <ion-grid>
                <ion-row size="auto" class="notepad">
                    <ion-col size="6" >
                        {{ 'selfEvaluation.reviewNotes' | translate }}
                    </ion-col>
                    <ion-col class="btns" size="6" >
                        <ion-button color="primary" *ngIf="this.onlyFinalFeedbackSeeReviews" (click)="viewReviews()">
                            {{ 'managerEvaluation.seeEvaluations' | translate | uppercase }}
                        </ion-button>
                        <ion-button color="primary" (click)="goToNotepad()" >
                            {{ 'selfEvaluation.seeNotes' | translate }}
                        </ion-button>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-item>

        <ion-item lines="none" mode="ios" class="para-content form">
            <form [formGroup]="formGroup" *ngIf="formGroup">
                <div *ngFor="let group of processConfig.questionsGroups | questionGroupAttributes: user?.attributes; let groupIndex = index;">
                    <ng-container *ngIf="(group.hasCalculateQuestions && !questionsType[QuestionType.Calculate].hidden) ||  !group.hasCalculateQuestions">
                        <h4>
                            {{ !hideQuestionNumber ? (groupIndex + 1) + ' - ' + getText(group.globalizationConfig, 'title') : getText(group.globalizationConfig, 'title') }}
                            <span class="tooltip" *ngIf="getText(group.globalizationConfig, 'instructions')"
                                  [matTooltip]="getText(group.globalizationConfig, 'instructions')"
                                  matTooltipClass="tooltip-content">?
                            </span>
                        </h4>
                    </ng-container>

                    <ng-container *ngFor="let question of group.questions">
                        <app-question-types [question]="question"
                                            [evaluation]="subordinateAnswers"
                                            [formGroup]="formGroup"
                        ></app-question-types>
                    </ng-container>
                </div>
            </form>
        </ion-item>

        <div class="bottom-buttons" *ngIf="canEdit" text-right>
            <ng-container>
                <ion-button
                        mode="ios"
                        color="primary"
                        class="save"
                        (click)="save(formGroup)"
                >
                    {{ 'generic.save' | translate }}
                </ion-button>
            </ng-container>
            <ion-button
                    mode="ios"
                    color="secondary"
                    class="save"
                    (click)="save(formGroup, true)"
            >
                {{ 'generic.sendEvaluation' | translate }}
            </ion-button>
        </div>
    </div>
</ion-content>
